import React from 'react';
import { connect } from 'react-redux';

import Tooltip from '../../../UI/Tooltip/Tootip';

const airlineStopover = (props) => {
    const FS = props.FS;
    const OD = props.OD;
    let totalStop = null;
    let stop0 = null;
    let stop1 = null;
    let stop2 = null;
    let stopCity0 = null;
    let stopCity1 = null;
    let stopCity2 = null;
    let stopOver = null;
    let allStopovers = [];
    let so0 = null;
    let so1 = null;
    let so2 = null;
    let so3 = null;
    if(FS.length === 1) {
        totalStop = 0;
        if(FS[0].so) {
            if(props.requestParams.originCountry !== "IN" || props.requestParams.destinationCountry !== "IN") {
                so0 = "Via " + FS[0].so.name;
            } else {
                so0 = FS[0].so;
            }
        }
    }
    if(FS.length > 1) {
        totalStop = OD.ts;
        if(FS.length === 2) {
            if(FS[0].so) {
                if(props.requestParams.originCountry !== "IN" || props.requestParams.destinationCountry !== "IN") {
                    so0 = "Via " + FS[0].so.name;
                } else {
                    so0 = FS[0].so;
                }
                allStopovers.push(so0);
            }
            if(allStopovers.length === 1) {
                stop0 = ","
            } else {
                stop0 = "Via"
            }
            stopCity0 = FS[0].aac;
            allStopovers.push(
                <span className={`u-fontSize13 u-phone-fontSize11 u-textColorMedium u-textAlignRight`}>
                    {stop0} <Tooltip type="stopCity" aria-label={props.cityNames[stopCity0]}>{stopCity0}</Tooltip>
                </span>
            );
            if(FS[1].so) {
                if(props.requestParams.originCountry !== "IN" || props.requestParams.destinationCountry !== "IN") {
                    if(allStopovers.length > 0) {
                        so1 = "," + FS[1].so.name;    
                    } else {
                        so1 = "Via" + FS[1].so.name;
                    }
                } else {
                    so1 = FS[1].so.split(' ')[1];
                }
                allStopovers.push(so1);
            }
        }
        if(FS.length === 3) {
            if(FS[0].so) {
                if(props.requestParams.originCountry !== "IN" || props.requestParams.destinationCountry !== "IN") {
                    so0 = "Via " + FS[0].so.name;
                } else {
                    so0 = FS[0].so;
                }
                allStopovers.push(so0);
            }
            if(allStopovers.length === 1) {
                stop0 = ",";
            } else {
                stop0 = "Via"
            }
            stopCity0 = FS[0].aac;
            allStopovers.push(
                <span className={`u-fontSize13 u-phone-fontSize11 u-textColorMedium u-textAlignRight`}>
                    {stop0} <Tooltip type="stopCity" aria-label={props.cityNames[stopCity0]}>{stopCity0}</Tooltip>
                </span>
            );
            if(FS[1].so) {
                if(props.requestParams.originCountry !== "IN" || props.requestParams.destinationCountry !== "IN") {
                    if(allStopovers.length > 0) {
                        so1 = "," + FS[1].so.name;    
                    } else {
                        so1 = "Via " + FS[1].so.name;
                    }
                } else {
                    so1 = FS[1].so.split(' ')[1];
                }
                allStopovers.push(so1);
            }
            if(allStopovers.length > 0) {
                stop1 = ",";
            } else {
                stop1 = "Via";
            }
            stopCity1 = FS[1].aac;
            allStopovers.push(
                <span className={`u-fontSize13 u-phone-fontSize11 u-textColorMedium u-textAlignRight`}>
                    {stop1} <Tooltip type="stopCity" aria-label={props.cityNames[stopCity1]}>{stopCity1}</Tooltip>
                </span>
            );
            if(FS[2].so) {
                if(props.requestParams.originCountry !== "IN" || props.requestParams.destinationCountry !== "IN") {
                    if(allStopovers.length > 0) {
                        so2 = ", " + FS[2].so.name;
                    } else {
                        so2 = "Via " + FS[2].so.name;
                    }
                } else {
                    so2 = FS[2].so.split(' ')[1];
                }
                allStopovers.push(so2);
            }
        }
    }
    if (totalStop === 0) {
        if(so0) {
            stop0 = so0;
        } else {
            stop0 = "Non Stop";
        }
        stopOver = <span className={`u-fontSize13 u-phone-fontSize11 u-textColorMedium u-textAlignRight`}>{stop0}</span>;
    } else if (totalStop >= 1) {
        stopOver = allStopovers;
    }
    return stopOver;
}

const mapStateToProps = state => {
    return {
        requestParams: state.flights.requestParams
    }
}

export default connect(mapStateToProps)(airlineStopover);



// WEBPACK FOOTER //
// ./src/components/Flight/Airline/AirlineStopover/AirlineStopover.js